import React, { useEffect } from "react";
import { createPortal } from "react-dom";

export interface ConfirmModalProps {
  show: boolean;
  title: string;
  messages?: string[];
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "warning" | "danger" | "primary";
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  show,
  title,
  messages = [],
  message,
  confirmLabel = "Continuar",
  cancelLabel = "Cancelar",
  variant = "warning",
  onConfirm,
  onCancel,
}) => {
  useEffect(() => {
    document.body.style.overflow = show ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [show]);

  if (!show) return null;

  const items = messages.length > 0 ? messages : message ? [message] : [];
  const iconClass =
    variant === "danger"
      ? "fas fa-exclamation-circle text-danger"
      : variant === "primary"
        ? "fas fa-info-circle text-primary"
        : "fas fa-exclamation-triangle text-warning";

  const confirmBtnClass =
    variant === "danger"
      ? "btn-danger"
      : variant === "primary"
        ? "btn-primary"
        : "btn-warning";

  return createPortal(
    <>
      <div className="modal-backdrop fade show" onClick={onCancel}></div>
      <div
        className="modal fade show d-block"
        tabIndex={-1}
        role="dialog"
        aria-modal="true"
        aria-labelledby="confirm-modal-title"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content shadow">
            <div className="modal-header border-0 pb-0">
              <h5 className="modal-title fw-bold" id="confirm-modal-title">
                <i className={`${iconClass} me-2`}></i>
                {title}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={onCancel}
                aria-label="Cerrar"
              ></button>
            </div>
            <div className="modal-body pt-3">
              {items.length === 1 ? (
                <p className="mb-0 text-muted">{items[0]}</p>
              ) : (
                <ul className="mb-0 ps-3 text-muted">
                  {items.map((item, index) => (
                    <li key={index} className="mb-2">
                      {item}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="modal-footer border-0 pt-0">
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={onCancel}
              >
                {cancelLabel}
              </button>
              <button
                type="button"
                className={`btn ${confirmBtnClass} fw-bold`}
                onClick={onConfirm}
              >
                {confirmLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>,
    document.body,
  );
};
